import { stitch } from 'keo';
import CircularProgress from 'material-ui/CircularProgress';
import PropTypes from 'prop-types';
import r from 'render-dom';

const propTypes = {
    style: PropTypes.object,
};

const baseStyle = {
    padding: 70,
    textAlign: 'center',
};

const render = ({ props: { style } }) => (
    r.div({ style: { ...baseStyle, ...style } }, [
        r(CircularProgress),
    ])
);

export default stitch({ propTypes, render });



// WEBPACK FOOTER //
// ./src/components/shared/Spinner/Spinner.js